import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { routerBasename } from './deployPaths'
import { ExpiredRouteRedirect } from './ExpiredRouteRedirect'
import { shellPathEntriesEnabled } from './shellPathEntries'
import { UnifiedShell } from './unified/UnifiedShell'

export function UnifiedApp() {
  const basename = routerBasename()
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<UnifiedShell />} />
        {shellPathEntriesEnabled() ? (
          <>
            <Route path="/legacy/:token" element={<UnifiedShell pathExperience="legacy" />} />
            <Route path="/new/:token" element={<UnifiedShell pathExperience="new" />} />
          </>
        ) : null}
        <Route path="/:token" element={<UnifiedShell />} />
        <Route path="*" element={<ExpiredRouteRedirect />} />
      </Routes>
    </BrowserRouter>
  )
}
